import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { loginAPI } from "../../services/login/actions";
import { setOrderId } from "../../services/orderHistory/actions";
import {
  formatPrice,
  formatUnit,
  getPriceOfTypeBasket,
} from "../../utils/priceUtils";
import { formatOrderWeight } from "../../utils/weightUtils";
import RemoveFromBasket from "../basket/RemoveFromBasket";
import ProductAmountCounter from "../products/ProductAmountCounter";

function TableComponent(props) {
  const getColumnComponent = (column, rowData) => {
    switch (column.dataName) {
      case "artikel":
        return (
          <div>
            <p1>{rowData.name}</p1>
            <br />
            <p1 style={{ color: "grey", fontSize: 12 }}>{rowData.code}</p1>
          </div>
        );
      case "number":
        if (rowData.product_id) {
          return (
            <ProductAmountCounter
              productId={rowData.product_id}
              amount={rowData.number}
            />
          );
        }
        return <ProductAmountCounter productId={rowData.id} />;
      case "numberShowOnly":
        return (
          <ProductAmountCounter
            productId={rowData.product_id}
            amount={rowData.number}
            screenType={"confirmOrder"}
          />
        );
      case "quantity":
        return <Box textAlign="center">{rowData[column.dataName]}</Box>;
      case "order_weight":
        return formatOrderWeight(rowData[column.dataName]);
      case "totalPrice":
        var totalPrice = getPriceOfTypeBasket(rowData);
        return formatPrice(totalPrice);
      case "salesprice":
        var price = formatPrice(rowData.salesprice);
        return formatUnit(rowData.order_weight, price);
      case "removeFromBasket":
        return (
          <RemoveFromBasket
            currentLocation={props.currentLocation}
            basketItem={rowData.id}
          />
        );
      case "arrow_button_order":
        return (
          <Link to="/singleOrder" style={{ textDecoration: "none" }}>
            <ArrowForwardIcon
              color="primary"
              onClick={() => {
                props.setOrderId(String(rowData.id));
              }}
            />
          </Link>
        );
      case "order_history_amount":
        return formatPrice(rowData.amount);
      default:
        return rowData[column.dataName];
    }
  };

  var { data, columnsMapping } = props;

  if (props.screenType === "orderHistory") {
    data = data
      .filter((row) => row.location === props.currentLocation.name)
      .map((filteredRows) => filteredRows);
  }

  if (!data?.length) {
    if (props.screenType === "orderHistory") {
      return <p align="center">U heeft nog geen orders voor deze locatie.</p>;
    } else {
      return <p align="center">Uw winkelmandje is leeg</p>;
    }
  }

  if (data && columnsMapping) {
    return (
      <TableContainer>
        <Table aria-label="spanning table">
          <TableHead>
            <TableRow>
              {columnsMapping.map((column) => (
                <TableCell align="left" style={{ paddingLeft: 0 }}>
                  <span
                    style={{
                      fontWeight: "bold",
                      textAlign: "left",
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    {column.name}
                  </span>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((rowData) => (
              <TableRow key={data.id}>
                {columnsMapping.map((column) => (
                  <TableCell align="left" style={{ paddingLeft: 0 }}>
                    {getColumnComponent(column, rowData)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  } else {
    return (
      <Box p={1}>
        <h1>Geen producten</h1>
      </Box>
    );
  }
}
const mapStateToProps = (state) => ({
  currentLocation: state.currentInformation.current_location,
  basketProducts: state.basket.products,
});

export default connect(mapStateToProps, {
  loginAPI,
  setOrderId,
})(TableComponent);
